export interface ModalPosition {
  x: number;
  y: number;
}

export interface RootStateI {
  version: string;
  sidebar: boolean;
  newEventModal: boolean;
  eventDetailsModal: boolean;
  plannerModal: boolean;
  eventModalPosition: ModalPosition | null;
  selectedDate: string;
  selectedEndDate: string;
  focusDate: string;
  viewMode: 'day' | 'week' | 'labour' | 'month' | 'year';
  editEventMode: boolean;
  newEventStartTime: string;
  newEventEndTime: string;
  plannerDate: string;
  dayEventsHoverModal: boolean;
  hoveredDate: string;
  hoverModalPosition: ModalPosition | null;
  dayEventsHoverModalEvents: any[];
}

export interface OptionI {
  content: string;
  action: string;
}

export interface PaginationI {
  page: number;
  limit: number;
  query: string;
}

export const state: RootStateI = {
  version: '0.0.1',
  sidebar: typeof window !== 'undefined' && localStorage.getItem('sidebarOpen') === 'true',
  newEventModal: false,
  eventDetailsModal: false,
  plannerModal: false,
  eventModalPosition: null,
  selectedDate: '',
  selectedEndDate: '',
  focusDate: '',
  viewMode: 'day',
  editEventMode: false,
  newEventStartTime: '',
  newEventEndTime: '',
  plannerDate: '',
  dayEventsHoverModal: false,
  hoveredDate: '',
  hoverModalPosition: null,
  dayEventsHoverModalEvents: [],
};
